import { useState } from "react";

export const faqs = [
  {
    q: "Do I need to drive to the St. Louis passport agency in person?",
    a: "No. As a registered State Department courier, we submit on your behalf with reserved access. O'Fallon residents simply mail us their documents overnight — no commute to Downtown St. Louis required.",
  },
  {
    q: "How fast can I get my passport from O'Fallon?",
    a: "As fast as 24 hours after your documents arrive at our DC office. For most O'Fallon residents, shipping overnight Monday means a passport by Wednesday. Exact timing depends on the selected service level.",
  },
  {
    q: "I'm a military family at Scott AFB with PCS orders. How do you help?",
    a: "We specialize in military family passport urgency. Bring your PCS orders, command endorsement (if required), and dependent documentation. We can often process military emergency cases within 24–48 hours.",
  },
  {
    q: "What's the difference between you and FedEx or Staples passport services?",
    a: "FedEx and Staples are resellers — they mark up our same courier service by 30–100%. We are a direct, registered State Department courier. Same result, significantly lower cost, plus professional document review before submission.",
  },
  {
    q: "My passport expires in 3 months. Can I still travel?",
    a: "Most countries require 6 months of passport validity beyond your travel dates. A passport expiring in 3 months will likely be rejected at customs. We recommend renewing immediately — we can expedite in 24–72 hours.",
  },
  {
    q: "Can O'Fallon residents track their passport application?",
    a: "Yes. We provide live case updates throughout the process — from document receipt through agency submission to final delivery.",
  },
  {
    q: "Is it safe to mail my original passport to you?",
    a: "Yes. We recommend FedEx or UPS overnight with tracking and insurance. We are a registered State Department courier with 20+ years of secure document handling. Your original passport is always tracked.",
  },
];

export default function OFallonFAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            O&apos;Fallon Passport Questions Answered
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left gap-4 hover:bg-[#F7F8FA] transition-colors"
              >
                <span className="font-semibold text-[#1A365D] text-sm">{faq.q}</span>
                <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#F6C344] text-lg flex-shrink-0`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-gray-500 text-sm leading-relaxed border-t border-gray-100 pt-3">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}